// extracted by mini-css-extract-plugin
export default {"editorContainer":"RichTextEditor_editorContainer__eT17z","toolbar":"RichTextEditor_toolbar__TlJp7","dark":"RichTextEditor_dark__2Om3+"};